import React from 'react';
import { ReactComponent as SharedIcon } from 'Assets/svg/share-icon.svg';
import './styles.scss';

const SharedListIcon = props => {
  const { data, condition, iconTitle = 'Shared list' } = props;

  const displayCondition =
    condition !== undefined ? condition : data?.isSharedList;

  return (
    displayCondition && (
      <span className="shared-icon-wrap">
        <SharedIcon title={iconTitle} />
      </span>
    )
  );
};

export default SharedListIcon;
